export interface IPayment {
  transactionId?: number;
  cardNo?: number;
  expiryDate?: string;
  cvv?: number;
  firstName?: string;
  lastName?: string;
  mobile?: string;
  email?: string;
  token?: string;
  question1?: string;
  answer1?: string;
  question2?: string;
  answer2?: string;
  question3?: string;
  answer3?: string;
  invoiceNo?: string;
  declineEmailPromo?: boolean;
}

export interface IAsiaPayResult {
  transactionId?: number;
  token?: string;
}
export const defaultValue: Readonly<IPayment> = {};
